import React, { useState } from 'react';
import { formatLastPosition } from './openTravelContract';
import useOpenTravels from './useOpenTravels';
import StageList from './StageList';
import { missing, place, travelCatalog } from './travelColumns';
import { deadlineColumn, travelDeadline } from './listColumns';

const noRows = [];
const places = (points, single) => (points?.length ? points.map(place).join(' · ') : place(single));
// Ordem da Lista de viagens no modelo novo (5671); a ordem das linhas vem do servidor (5586).
const ORDER = [
  'position',
  'deadline',
  'travel',
  'reference',
  'status',
  'client',
  'product',
  'amount',
  'carrier',
  'driver',
  'driverPhone',
  'vehicle',
  'link',
  'payable',
  'origin',
  'destination',
  'km',
  'kmCovered',
  'kmRemaining',
  'transitTime',
  'arrival',
  'pickup',
  'delivery',
  'loadingStarted',
  'loadingFinished',
  'unloadingStarted',
  'unloadingFinished',
  'tracking',
  'lastPosition',
  'observations',
  'updated',
  'responsible',
  'costCenter',
];

export default function OpenTripsList({ context, tabs, onPerPageChange, rowIntegrations = {} }) {
  const [page, setPage] = useState(1);
  const { data, loading, error, refresh } = useOpenTravels({
    companyId: context.companyId,
    page,
    perPage: context.query.perPage,
    filters: context.query.filters,
  });
  const listContext = {
    ...context,
    query: { ...context.query, pages: { ...context.query.pages, TRIPS: page } },
  };
  const {
    occurrences: Occurrences,
    transitTimeProvider: TransitTimeProvider,
    travelProgressValue: ProgressValue,
  } = rowIntegrations;
  const integrationProps = (item) => ({
    item,
    context: { ...listContext, group: item.group },
    onChanged: refresh,
  });
  const base = travelCatalog({ Occurrences, ProgressValue, integrationProps });
  // Diferenças da lista consolidada: ordem do servidor, Viagem Benner pelo número da viagem,
  // todos os pontos da rota, posição da própria resposta e prazo por status.
  const catalog = {
    ...base,
    position: {
      key: 'order',
      label: '#',
      width: 50,
      resizable: false,
      value: (row) => String(row.order).padStart(2, '0'),
    },
    reference: {
      key: 'reference',
      label: 'Viagem Benner',
      width: 175,
      value: (row) => row.travelNumber || missing,
    },
    origin: { ...base.origin, value: (row) => places(row.origins, row.origin) },
    destination: { ...base.destination, value: (row) => places(row.destinations, row.destination) },
    lastPosition: {
      key: 'lastPosition',
      label: 'Posição',
      width: 350,
      value: (row) => formatLastPosition(row.lastPosition),
    },
    // Previsão De Chegada só para viagens Em viagem.
    arrival: {
      ...base.arrival,
      render: (row, value) =>
        row.group === 'IN_TRANSIT' ? base.arrival.render(row, value) : missing,
    },
    deadline: deadlineColumn((row) => travelDeadline(row)),
  };
  const columns = ORDER.map((key) => catalog[key]);
  const list = (
    <StageList
      definition={{
        code: 'TRIPS',
        title: 'LISTA VIAGENS',
        className: 'tc-k-open-travel-list',
        loadingLabel: 'viagens em aberto',
        emptyMessage: 'Nenhuma viagem em aberto.',
        tableLabel: 'Lista consolidada de viagens',
      }}
      columns={columns}
      context={listContext}
      queryState={{ groups: data ? { TRIPS: data } : null, loading, error }}
      onPageChange={setPage}
      onPerPageChange={(value) => {
        setPage(1);
        onPerPageChange(value);
      }}
      onRefresh={refresh}
      tabs={tabs}
    />
  );
  // KM Restante, Previsão, Responsável e CC vêm do travel-progress das viagens da página.
  return TransitTimeProvider ? (
    <TransitTimeProvider context={listContext} rows={data?.data || noRows}>
      {list}
    </TransitTimeProvider>
  ) : (
    list
  );
}
